import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import References from './components/References';
import Footer from './components/Footer';
import ServicesPage from './pages/ServicesPage';
import ServiceDetail from './pages/ServiceDetail';
import WhatsAppButton from './components/WhatsAppButton';
import MetaTags from './components/MetaTags';

function HomePage() {
  return (
    <>
      <MetaTags 
        title="Profesyonel Temizlik Hizmetleri"
        description="Bektaş Temizlik profesyonel çözümler sunar. %100 müşteri memnuniyeti garantisi."
        keywords="temizlik şirketi, temizlik, ofis temizliği, tadilat sonrası temizlik, profesyonel temizlik, temizlik hizmetleri, istanbul temizlik şirketi"
      />
      <Hero />
       <About />
      <ServicesPage />
      <References />
    </>
  );
}

// URL değişikliklerini dinleyen bileşen
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Sayfa yüklendiğinde veya URL değiştiğinde çalışır
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Hash yoksa sayfanın en üstüne çık
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white relative overflow-hidden">
        {/* Main content - z-index 1 */}
        <div style={{
          position: 'relative',
          zIndex: 1,
          minHeight: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(2px)',
          WebkitBackdropFilter: 'blur(2px)',
        }}>
          <Header />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/hizmetler/:id" element={<ServiceDetail />} />
          </Routes>
          <Footer />
        </div>

        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;